import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator } from './components/sliders.js';
import { showMoreFaqs, accordion } from './components/accordion.js';

document.addEventListener("DOMContentLoaded", function () {
  slickSliderGenerator('brand', '.logos-container');
  slickSliderGenerator('features', '.features-container');
  slickSliderGenerator('workflow_normal', '.workflow-normal-container');
  accordion('.faqs-cards');
  showMoreFaqs();
  getSVG();
});
